// @ts-nocheck
import {
    ArrayInput,
    AutocompleteInput,
    BooleanInput,
    Button,
    CheckboxGroupInput,
    DateInput,
    DateTimeInput,
    FileInput,
    Labeled,
    NumberInput,
    SelectArrayInput,
    SelectInput,
    TextInput,
} from 'react-admin';

Labeled.defaultProps = {
    spacing: 0,
};

Button.defaultProps = {
    size: 'medium',
};

TextInput.defaultProps = {
    helperText: false,
};

NumberInput.defaultProps = {
    helperText: false,
};

SelectInput.defaultProps = {
    helperText: false,
};

SelectArrayInput.defaultProps = {
    variant: 'outlined',
    helperText: false,
};

ArrayInput.defaultProps = {
    helperText: false,
};

DateInput.defaultProps = {
    helperText: false,
};

CheckboxGroupInput.defaultProps = {
    helperText: false,
};

AutocompleteInput.defaultProps = {
    helperText: false,
};

BooleanInput.defaultProps = {
    helperText: false,
};

DateTimeInput.defaultProps = {
    helperText: false,
};

FileInput.defaultProps = {
    helperText: false,
};

export {
    ArrayInput,
    AutocompleteInput,
    BooleanInput,
    Button,
    CheckboxGroupInput,
    DateInput,
    DateTimeInput,
    FileInput,
    Labeled,
    NumberInput,
    SelectArrayInput,
    SelectInput,
    TextInput,
};
